import { MutableRefObject } from 'react';
import jsPDF from 'jspdf';
import { getSimulationDataForWaterfall } from 'views/simulations/result-overview/result-utils';
import { formatToMillions } from 'client/common/format-data/format-to-millions.ts';
import autoTable from 'jspdf-autotable';
import { addChart } from 'views/report/utils/add-chart/add-chart.ts';
import { lineInterval } from 'views/report/utils/style-consts.ts';
import { addTitle } from 'views/report/utils/add-title/add-title.ts';

export const addSectionWaterfallCostPage = async (
  doc: jsPDF,
  padding: number,
  forecastLogoHeight: number,
  chartRef: MutableRefObject<null>,
  simulationsResult: any,
  primaryCurrency: string,
) => {
  doc.addPage();

  addTitle(doc, 'Section Waterfall (Cost)', {
    x: padding,
    y: forecastLogoHeight + padding + lineInterval,
  });

  const chart = await addChart(doc, chartRef);

  const { sections, values, totalSum } = getSimulationDataForWaterfall(simulationsResult, 1);
  const rows =
    sections?.labels?.map((section: string, idx: number) => [
      { content: section, styles: { fontStyle: 'bold' } },
      formatToMillions(values[idx]),
    ]) || [];
  const tableStartY = padding + forecastLogoHeight + chart.chartHeight + 2 * lineInterval;
  autoTable(doc, {
    head: [['Section', `Cost [M${primaryCurrency}]`]],
    body: [...rows, [{ content: 'Total', styles: { fontStyle: 'bold' } }, formatToMillions(totalSum)]],
    startY: tableStartY,
    theme: 'plain',
    columnStyles: {
      0: { cellWidth: 60 },
      1: { cellWidth: 'auto' },
    },
    styles: {
      fontSize: 10,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 0 },
      halign: 'left',
    },

    didDrawCell: (data) => {
      const { cell, doc } = data;
      const { x, y, width, height } = cell;
      // Draw bottom border for each cell
      doc.setDrawColor('#90908d');
      doc.setLineWidth(0.2);
      doc.line(x, y + height, x + width, y + height);
    },
    margin: { top: 30 },
  });
};
